<template>	
  <b-container fluid >        
    <b-tabs justified>
        <b-tab title="Validación" active>
            <b-row>
                <b-col>
                    
                            <b-row align-h="center">
                            
                                <b-col cols="11" md="4">
                                    <b-form-input placeholder="PLACA" v-model="placa" size="lg"></b-form-input>
                                </b-col>
                                
                                <b-col cols="11" md="12" class="mt-3 "  >
                                    <b-button :disabled="placa==null||placa==''" @click="consultaParquimetroUsr('0')"  block variant="success" size="lg">
                                        <strong> Consulta Placa </strong>
                                        <b-spinner v-if="consultando"></b-spinner>
                                    </b-button>
                                </b-col>
                                
                                
                            </b-row>           
                </b-col>
            </b-row>
        </b-tab>
        <b-tab title="Infracción">
            <b-row>
                <b-col cols="12"><h6>Placa</h6><b-form-input v-model="placaIn" size="lg"></b-form-input></b-col>
                <b-col cols="12"><h6>Marca</h6><b-form-input v-model="marcaIn" size="lg"></b-form-input></b-col>
                <b-col cols="12"><h6>Modelo</h6><b-form-input v-model="modeloIn" size="lg"></b-form-input></b-col>
                <b-col cols="12"><h6>Color</h6><b-form-input v-model="colorIn" size="lg"></b-form-input></b-col>
                <b-col cols="12" class="mt-3"><b-button block size="lg" variant="success" @click="generaInfraccion">Generar <b-spinner v-if="consultando"></b-spinner></b-button></b-col>
            </b-row>
        </b-tab>
    </b-tabs>

    
    <b-modal :title="estatus.placa" header-bg-variant="dark" header-text-variant="light" hide-footer v-model="showEstado">
        <b-row align="center">
            <b-col cols="12"><h2>{{estatus.vigente?"VIGENTE":"--"}}</h2></b-col>
            <b-col cols="12" v-if="estatus.minutos!=null && !estatus.minutos.includes('-')"><h4>{{estatus.minutos}} minutos</h4></b-col>
            <b-col cols="12"><h5>{{estatus.fin}}</h5></b-col>
            <b-col cols="12"><h6>{{estatus.msg}}</h6></b-col>
            <b-col cols="12" class="mt-3 mb-2" v-if="estatus.ultTolerancia!=null && estatus.ultTolerancia.includes('>') && !estatus.vigente"><h6 style="color:red">Inicio tolerancia: {{estatus.ultTolerancia}}</h6></b-col>
            <b-col cols="12" class="mt-3 mb-2" v-if="estatus.ultTolerancia!=null && estatus.ultTolerancia.includes('<') && !estatus.vigente"><h6 style="color:green">Inicio tolerancia: {{estatus.ultTolerancia}}</h6></b-col>
        </b-row>
        <b-row v-if="estatus.ultTolerancia!=null && (estatus.ultTolerancia.includes('>')||estatus.ultTolerancia.includes('-')) && !estatus.vigente">
            <b-col cols="11" md="12" class="mt-3 "  >
                <b-button  @click="consultaParquimetroUsr('1')"  block variant="success" size="lg">
                    <strong> Iniciar tolerancia (10 min) </strong>
                    <b-spinner v-if="consultando"></b-spinner>
                </b-button>
            </b-col>
        </b-row>
    </b-modal>
  </b-container>
</template>

<script>
    import { mapState} from 'vuex'
    import axios from 'axios'
    import { server, getPostConfig} from '@/axios-tools'
    import { downloadB64Pdf } from '@/vue-tools'
    
    export default {
        computed: mapState({
            parcialidades: state => state.cobro.parcialidades,
            totalLiquidacion: state => state.cobro.totalLiquidacion,
            token: state => state.login.token,
            datosPago: state => state.cobro.datosPago,
            isCobrando: state => state.cobro.isCobrando,
            catalogCobro: state => state.cobro.catalogCobro
            
            
        }),
        data(){
            return{

                /* Usados para integrar recibos IUSA */ 
                placa:'',
                consultando:false,

                showEstado:false,
                estatus :  { placa: '',
                            vigente: false,
                            fin: "",
                            minutos: "",
                            msg: ""
                                    },

                placaIn:"",
                marcaIn:"",
                modeloIn:"",
                colorIn:"",


            }
        },
       
        methods: {
           
            consultaParquimetroUsr(reset){
                if(!this.consultando){
                    this.consultando=true;

                    axios(
                        
                        getPostConfig(server.consultaparquimetrousr, {placa:this.placa}, this.token, {reset:reset, latLng:''})
                        
                    )
                    .then(res => {
                        this.estatus = res.data;
                        this.showEstado = true;
                        this.consultando = false;

                    }).catch(e => {
                        alert(e);
                        
                        this.consultando = false;
                        
                    });
                }
            },
            generaInfraccion(){
                if(!this.consultando){
                    this.consultando=true;

                    axios(
                        
                        getPostConfig(server.geninfraccion, {}, this.token, {placa:this.placaIn, marca:this.marcaIn, modelo:this.modeloIn, color:this.colorIn})
                        
                    )
                    .then(res => {
                        
                        downloadB64Pdf(res.data, 'infraccion.pdf');
                        this.consultando = false;

                    }).catch(e => {
                        alert(e);
                        
                        this.consultando = false;
                        
                    });
                }
            },
            
        },
       
    }
</script>
<style>
div.error    {color: red;}
</style>